import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Button, Form, Modal, Badge, Spinner, Dropdown, DropdownButton } from "react-bootstrap";
import { getCustomerServices, addService, extendService } from "../services/servicesService";
import { getCustomerEquipments } from "../services/equipmentService";
import { getTariffsForCustomer } from "../services/tariffService";
import FormComponent from "./common/formComponent";
import { formatNumber } from "../services/util";
import FloatingAddButton from "./common/floatingAddButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PageLoading from "./common/pageLoading";
import { isSuperAdmin } from "../services/authService";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";

class CustomerServices extends FormComponent {
  state = {
    data: {
      daysToExtend: 0,
      tariffId: "",
      equipmentId: "",
    },
    customerId: this.props.match.params.id,
    errors: {},
    action: "add",
    equipments: [],
    services: [],
    tariffs: [],
    equipmentTariffs: [],
    showAddModal: false,
    showExtensionModal: false,
    serviceToModify: {},
    loading: true,
    processing: false,
  };

  schema = {
    daysToExtend: Joi.number().min(0).max(5).required().label("Days To Extend"),
    tariffId: Joi.string().required().label("Tariff"),
    equipmentId: Joi.string().required().label("Equipment"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      const { data: payload, services, serviceToModify, action } = this.state;

      let newService = {};
      if (action === "add") {
        const { data } = await addService(payload);
        newService = data;
      } else if (action === "extend") {
        const { data } = await extendService(payload, serviceToModify._id);
        newService = data;
      }

      services.unshift(newService);
      this.setState({
        services,
        showAddModal: false,
        showExtensionModal: false,
      });

      let message = "Action Completed Successfully";

      toast.success(message);
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    await this.populateEquipments();
    await this.populateServices();

    if (this.state.equipments.length > 0) {
      await this.populateTariffs();
    }

    this.setState({ loading: false });
  }

  async populateEquipments() {
    const { customerId } = this.state;

    try {
      const { data: equipments } = await getCustomerEquipments(customerId);
      this.setState({ equipments });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateTariffs() {
    const { customerId } = this.state;

    try {
      const { data: equipmentTariffs } = await getTariffsForCustomer(customerId);
      this.setState({ equipmentTariffs });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateServices() {
    const { equipments } = this.state;

    let equipmentIds = "";
    for (var i = 0; i < equipments.length; i++) {
      const id = equipments[i]._id;
      equipmentIds += id + ",";
    }

    try {
      const { data: services } = await getCustomerServices(equipmentIds);
      this.setState({ services });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  handleShowAddModal = () => {
    this.setState({ showAddModal: true });
  };

  handleShowExtensionModal = (serviceToModify) => {
    const data = { ...this.state.data };
    data.equipmentId = serviceToModify.equipmentId;
    data.tariffId = serviceToModify.tariffId;
    this.setState({ data, serviceToModify, action: "extend", showExtensionModal: true });
  };

  handleClose = () => {
    // const data = { ...this.state.data };
    // data.equipmentId = "";
    // data.tariffId = "";
    // set data
    this.setState({
      showAddModal: false,
      showChangeModal: false,
      showExtensionModal: false,
    });
  };

  handleSelectEquipment = async (e) => {
    const equipmentId = e.currentTarget.value;

    if (equipmentId === "") {
      // const tariffs = [];
      // this.setState({ tariffs });
    } else {
      const { equipmentTariffs } = this.state;
      const data = { ...this.state.data };
      data.equipmentId = equipmentId;
      const tariffs = equipmentTariffs[equipmentId];
      this.setState({ data, tariffs });
    }
  };

  render() {
    const {
      services,
      serviceToModify,
      equipments,
      tariffs,
      errors,
      data,
      showAddModal,
      showExtensionModal,
      loading,
      processing,
    } = this.state;
    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && services.length === 0 && <span className="float-left mt-4">No Services to Display</span>}
        {!loading && <FloatingAddButton classes="float-right mt-2 mb-3 ml-3" onClick={this.handleShowAddModal} />}
        {!loading && services.length > 0 && (
          <TableContainer component={Paper} className="mt-4">
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Tariff</StyledTableCell>
                  <StyledTableCell align="right">Equipment</StyledTableCell>
                  <StyledTableCell align="right">Start Date</StyledTableCell>
                  <StyledTableCell align="right">End Date</StyledTableCell>
                  <StyledTableCell align="right">Type</StyledTableCell>
                  <StyledTableCell align="right">Status</StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {services.map((service) => (
                  <StyledTableRow key={service._id}>
                    <StyledTableCell component="th" scope="row">
                      {service.tariff}
                    </StyledTableCell>
                    <StyledTableCell align="right">{service.equipment}</StyledTableCell>
                    <StyledTableCell align="right">{service.formattedStartDate}</StyledTableCell>
                    <StyledTableCell align="right">{service.formattedEndDate}</StyledTableCell>
                    <StyledTableCell align="right">{service.type}</StyledTableCell>
                    <StyledTableCell align="right">
                      <Badge variant={`${service.status === "Active" ? "success" : "danger"}`}>{service.status}</Badge>
                    </StyledTableCell>
                    {service.isLatestService && (
                      <StyledTableCell align="right">
                        <DropdownButton className="mb-2" size="sm" id="dropdown-success-button" title="Actions">
                          {isSuperAdmin() && (
                            <Dropdown.Item onClick={() => this.handleShowExtensionModal(service)}>Extend</Dropdown.Item>
                          )}
                          <Dropdown.Item>Block</Dropdown.Item>
                          <Dropdown.Item>Activate</Dropdown.Item>
                        </DropdownButton>
                      </StyledTableCell>
                    )}
                    {!service.isLatestService && <StyledTableCell align="right"></StyledTableCell>}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Modal show={showAddModal} size="md" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Service</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <React.Fragment>
                <Form.Group controlId="equipment">
                  <Form.Label>Equipment</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name="equipmentId"
                    onChange={this.handleSelectEquipment}
                    value={data.equipmentId}
                    size="sm"
                  >
                    <option value="">Select Equipment</option>
                    {equipments.map((equipment) => (
                      <option key={equipment._id} value={equipment._id}>
                        {equipment.name} ({equipment.sn})
                      </option>
                    ))}
                  </Form.Control>
                  {errors.equipmentId && <span className="text-danger">{errors.equipmentId}</span>}
                </Form.Group>

                {tariffs && tariffs.length > 0 && (
                  <Form.Group controlId="tariff">
                    <Form.Label>Tariff</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      name="tariffId"
                      onChange={this.handleChange}
                      value={data.tariffId}
                      size="sm"
                    >
                      <option value="">Select Tariff</option>
                      {tariffs.map((tariff) => (
                        <option key={tariff._id} value={tariff._id}>
                          {tariff.title} - &#8358;{formatNumber(tariff.price)}
                        </option>
                      ))}
                    </Form.Control>
                    {errors.equipmentId && <span className="text-danger">{errors.equipmentId}</span>}
                  </Form.Group>
                )}
              </React.Fragment>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Add
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal show={showExtensionModal} size="md" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Extend Service: {serviceToModify.tariff}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <React.Fragment>
                <Form.Group controlId="daysToExtend">
                  <Form.Label>Number of Days</Form.Label>
                  <Form.Control
                    name="daysToExtend"
                    onChange={this.handleChange}
                    value={data.daysToExtend}
                    size="sm"
                    type="text"
                  />
                  {errors.daysToExtend && <span className="text-danger">{errors.daysToExtend}</span>}
                </Form.Group>
              </React.Fragment>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button disabled={this.validate() || processing} type="submit" variant="primary">
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Extend Service
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default CustomerServices;
